// extracted by mini-css-extract-plugin
export default {"image":"style_image__x1Kho","primaryImg":"style_primaryImg__I72cu","options":"style_options__FsFvO"};